import React, { useState, useCallback, useEffect } from "react";
import { Link } from "react-router-dom";
// import "../../../Utils/css/Mission.css";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import paginationFactory from "react-bootstrap-table2-paginator";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import moment from "moment";
import "../../../../utils/Css/Mission.css";
import {
  getAllMissionEnCours,
  getAllMissionsEnHistorique,
  updateOrdreDeMission,
} from "../../../../services/RHService/OrdreDeMissionService";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";

const Employeemissionlist = () => {
  const [showModifyform, setShowModifyform] = useState(false);
  const handleCloseModifyform = () => setShowModifyform(false);
  const [employeesEnCours, setEmployeesEnCours] = useState([]);
  const [employeesEnHistorique, setEmployeesEnHistorique] = useState([]);
  const [selectedMission, setSelectedMission] = useState([]);
  const [inputList, setInputList] = useState([]);
  const fetchAllMissionEnCours = async () => {
    try {
      const response = await getAllMissionEnCours(getCurrentUserId());
      console.log(response);

      setEmployeesEnCours(response.success);
      console.log(response);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchAllMissionEnCours();
  }, []);
  const fetchAllMissionEnHistorique = async () => {
    try {
      const response = await getAllMissionsEnHistorique(getCurrentUserId());
      setEmployeesEnHistorique(response.success);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchAllMissionEnHistorique();
  }, []);

  //afficher les information par defaut dans le Model
  const handleShowModifyform = (mission) => {
    setSelectedMission(mission);
    setInputList(mission.charges);
    setShowModifyform(true);
  };
  //charges
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };

  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };
  const handleAddClick = () => {
    setInputList([
      ...inputList,
      { nomCharge: "", frais: "", isDeleted: false },
    ]);
  };
  useEffect(() => {
    setSelectedMission((prevState) => ({
      ...prevState,
      charges: inputList,
    }));
  }, [inputList]);
  //charges
  const historiquecolumns = [
    {
      dataField: "id",
      text: "Mat",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
    },
    {
      dataField: "personnel",
      text: "Personnel",
      formatter: (cell, row) => `${row.firstname} ${row.lastname}`,
    },
    { dataField: "intitule", text: "Intitulé de mission" },
    { dataField: "villeDept", text: "Ville de départ" },
    { dataField: "villeDest", text: "Ville destination" },
    { dataField: "dateDeb", text: "Date Départ" },
    { dataField: "dateFin", text: "Date fin" },
    { dataField: "envoyerPar", text: "Envoyé par" },
    {
      dataField: "dd",
      text: "Tot.Charge",
      formatter: (cell, row) => `${row.totCharge} Dt`,
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: (cell, row) => {
        return (
          <div className="center">
            <Button
              type="button"
              style={{
                "background-color": "#696969",
                "border-color": "transparent",
                "border-radius": "0px",
              }}
            >
              <Link to={`/missionDetails?idMission=${row.idMission}`}>
                <i
                  className="fa-solid fa-eye eye-icon"
                  style={{ color: "white" }}
                ></i>
              </Link>
            </Button>
          </div>
        );
      },
    },
  ];
  //colonnes de table
  const columns = [
    {
      dataField: "id",
      text: "Mat",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
    },
    {
      dataField: "personnel",
      text: "Personnel",
      formatter: (cell, row) => `${row.firstname} ${row.lastname}`,
    },
    { dataField: "intitule", text: "Intitulé M." },
    { dataField: "villeDept", text: "Ville Dep." },
    { dataField: "villeDest", text: "Ville Dest." },
    { dataField: "dateDeb", text: "Date D." },
    { dataField: "dateFin", text: "Date F." },
    { dataField: "envoyerPar", text: "Envoyé par" },
    {
      dataField: "dd",
      text: "Tot.Charge",
      formatter: (cell, row) => `${row.totCharge} Dt`,
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: (cell, row) => {
        return (
          <div className="center" style={{ display: "flex" }}>
            <Button
              className="mx-1"
              style={{
                "background-color": "#000",
                color: "white",
                "border-color": "transparent",
                "border-radius": "0px",
              }}
              onClick={() => {
                handleShowModifyform(row);
              }}
            >
              <i className="fa-solid fa-pencil me-1"></i>
            </Button>
            <Button
              type="button"
              style={{
                "background-color": "#696969",
                color: "white",
                "border-color": "transparent",
                "border-radius": "0px",
              }}
            >
              <Link to={`/missionDetails?idMission=${row.idMission}`}>
                <i
                  className="fa-solid fa-eye eye-icon "
                  style={{ color: "white" }}
                ></i>
              </Link>
            </Button>
          </div>
        );
      },
    },
  ];
  //pagination
  const options = {
    sizePerPage: 5,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    paginationPosition: "bottom",
  };
  //hisorique pagination
  const historiqueoptions = {
    sizePerPage: 5,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    paginationPosition: "bottom",
  };

  //Update
  const handleUpdate = async (event) => {
    event.preventDefault();
    // Convert date format to "dd/MM/yyyy"
    const { dateDeb, dateFin, ...otherFormData } = selectedMission;
    const formattedFormData = {
      ...otherFormData,
      dateDeb: moment(selectedMission.dateDeb).format("YYYY-MM-DD"),
      dateFin: moment(selectedMission.dateFin).format("YYYY-MM-DD"),
    };

    try {
      await updateOrdreDeMission(
        formattedFormData.idMission,
        formattedFormData
      );
      fetchAllMissionEnCours();
      handleCloseModifyform();
    } catch (error) {
      alert(error.message);
    }
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <ToolkitProvider keyField="id">
        {(props) => (
          <div>
            {/* Modify Mission Modal */}
            <Modal
              show={showModifyform}
              onHide={handleCloseModifyform}
              size="xl"
            >
              <Modal.Header closeButton>
                <Modal.Title>Modifier les informations</Modal.Title>
              </Modal.Header>
              <Modal.Body className="show-grid">
                <Form onSubmit={handleUpdate}>
                  <Container>
                    <Row>
                      <Col xs={12} md={6}>
                        <div className="form-group">
                          <label>Intitulé de mission</label>
                          <input
                            type="text"
                            name="intitule"
                            value={
                              selectedMission ? selectedMission.intitule : ""
                            }
                            onChange={(e) =>
                              setSelectedMission({
                                ...selectedMission,
                                intitule: e.target.value,
                              })
                            }
                            className="form-control form-control-border"
                            placeholder="Intitulé de mission "
                          />
                        </div>
                        <div className="form-group">
                          <label>Ville de départ</label>
                          <input
                            type="text"
                            className="form-control form-control-border"
                            name="villeDept"
                            value={
                              selectedMission ? selectedMission.villeDept : ""
                            }
                            onChange={(e) =>
                              setSelectedMission({
                                ...selectedMission,
                                villeDept: e.target.value,
                              })
                            }
                            placeholder="Ville de départ"
                          />
                        </div>
                        <div className="form-group">
                          <label>Ville de destination</label>
                          <input
                            type="text"
                            className="form-control form-control-border"
                            name="villeDest"
                            value={
                              selectedMission ? selectedMission.villeDest : ""
                            }
                            onChange={(e) =>
                              setSelectedMission({
                                ...selectedMission,
                                villeDest: e.target.value,
                              })
                            }
                            placeholder="Ville de destination"
                          />
                        </div>
                        <div className="form-group">
                          <label>pays destination</label>
                          <input
                            type="text"
                            className="form-control form-control-border"
                            name="paysDest"
                            value={
                              selectedMission ? selectedMission.paysDest : ""
                            }
                            onChange={(e) =>
                              setSelectedMission({
                                ...selectedMission,
                                paysDest: e.target.value,
                              })
                            }
                            placeholder="pays destination"
                          />
                        </div>
                        <div className="form-group">
                          <label>Date de départ</label>
                          <div
                            className="input-group date"
                            data-target-input="nearest"
                          >
                            <input
                              type="date"
                              id="start"
                              name="dateDeb"
                              value={
                                selectedMission ? selectedMission.dateDeb : ""
                              }
                              onChange={(e) =>
                                setSelectedMission({
                                  ...selectedMission,
                                  dateDeb: e.target.value,
                                })
                              }
                              min="1900-01-01"
                              className="form-control form-control-border "
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} md={6}>
                        <div className="form-group">
                          <label>Date de fin</label>
                          <div
                            className="input-group date"
                            id="reservationdate"
                            data-target-input="nearest"
                          >
                            <input
                              type="date"
                              id="start"
                              name="dateFin"
                              value={
                                selectedMission ? selectedMission.dateFin : ""
                              }
                              onChange={(e) =>
                                setSelectedMission({
                                  ...selectedMission,
                                  dateFin: e.target.value,
                                })
                              }
                              min="1900-01-01"
                              className="form-control form-control-border"
                            />
                          </div>
                        </div>
                        <div class="form-group">
                          <label>Heure Début</label>
                          <div
                            class="input-group date"
                            id="reservationdatetime"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control form-control-border "
                              type="time"
                              id="appt"
                              name="heureDeb"
                              value={
                                selectedMission ? selectedMission.heureDeb : ""
                              }
                              onChange={(e) =>
                                setSelectedMission({
                                  ...selectedMission,
                                  heureDeb: e.target.value,
                                })
                              }
                              min="09:00"
                            />
                          </div>
                        </div>
                        <div class="form-group">
                          <label>Heure fin</label>
                          <div
                            class="input-group date"
                            id="reservationdatetime"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control form-control-border "
                              type="time"
                              id="appt"
                              min="09:00"
                              name="heureFin"
                              value={
                                selectedMission ? selectedMission.heureFin : ""
                              }
                              onChange={(e) =>
                                setSelectedMission({
                                  ...selectedMission,
                                  heureFin: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label>Description</label>
                          <textarea
                            type="Textarea"
                            name="desc"
                            value={selectedMission ? selectedMission.desc : ""}
                            onChange={(e) =>
                              setSelectedMission({
                                ...selectedMission,
                                desc: e.target.value,
                              })
                            }
                            rows="2"
                            cols="33"
                            className="form-control form-control-border"
                            placeholder="Description"
                          ></textarea>
                        </div>
                        <label>Accusations :</label>
                        {selectedMission && selectedMission.charges ? (
                          selectedMission.charges.map((charge, index) => (
                            <div className="col-md-3" key={index}>
                              <div className="box">
                                <input
                                  name="nomCharge"
                                  className="form-control form-control-border"
                                  placeholder="Nom de charge"
                                  value={charge.nomCharge}
                                  onChange={(e) => handleInputChange(e, index)}
                                />
                                <input
                                  name="frais"
                                  className="form-control form-control-border ml10"
                                  placeholder="Charge"
                                  value={charge.frais}
                                  onChange={(e) => handleInputChange(e, index)}
                                />
                                <input
                                  name="isDeleted"
                                  hidden
                                  value={charge.isDeleted}
                                  onChange={(e) => handleInputChange(e, index)}
                                />
                                <div className="btn-box">
                                  {selectedMission.charges.length > 1 && (
                                    <button
                                      className="mr10 mx-1 m-1"
                                      type="button"
                                      style={{
                                        backgroundColor: "black",
                                        color: "white",
                                        borderRadius: "50%",
                                        borderColor: "black",
                                      }}
                                      onClick={() => handleRemoveClick(index)}
                                    >
                                      <i className="fa-solid fa-minus"></i>
                                    </button>
                                  )}
                                  {selectedMission.charges.length - 1 ===
                                    index && (
                                    <button
                                      onClick={handleAddClick}
                                      type="button"
                                      style={{
                                        backgroundColor: "black",
                                        color: "white",
                                        borderRadius: "50%",
                                        borderColor: "black",
                                      }}
                                    >
                                      <i className="fa-solid fa-plus"></i>
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <p>Loading charges...</p>
                        )}
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModifyform}>
                  Fermer
                </Button>
                <Button variant="dark" onClick={handleUpdate}>
                  Modifier
                </Button>
              </Modal.Footer>
            </Modal>
            {/* Modify Mission Modal */}
            {/* header */}
            <div className="content-header">
              <div className="container-fluid">
                <div className="row mb-2">
                  <div className="col-sm-6">
                    <h1 className="m-0">Liste des ordres de mission</h1>
                  </div>
                  <div className="col-sm-6">
                    <ol className="breadcrumb float-sm-right">
                      <li className="breadcrumb-item">
                        <i class="fa-solid fa-house"></i>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                      </li>
                      <li className="breadcrumb-item active">
                        <Link to="/mission_order">Ordre de mission </Link>
                      </li>
                      <li className="breadcrumb-item active">
                        Liste des ordre de mission
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-header d-flex p-0">
                      <ul class="nav nav-pills ml-auto p-2">
                        <li class="nav-item">
                          <a
                            class="nav-link active mycolorhoverclass"
                            href="#tab_1"
                            data-toggle="tab"
                          >
                            En Mission
                          </a>
                        </li>
                        <li class="nav-item">
                          <a
                            class="nav-link mycolorhoverclass"
                            href="#tab_2"
                            data-toggle="tab"
                          >
                            Histotique des ordres de mission
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div class="card-body">
                      <div class="tab-content">
                        <div class="tab-pane active" id="tab_1">
                          <BootstrapTable
                            {...props.baseProps}
                            data={employeesEnCours}
                            columns={columns}
                            bordered={false}
                            pagination={paginationFactory(options)}
                          />
                        </div>

                        <div class="tab-pane" id="tab_2">
                          <BootstrapTable
                            {...props.baseProps}
                            data={employeesEnHistorique}
                            columns={historiquecolumns}
                            bordered={false}
                            pagination={paginationFactory(historiqueoptions)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </ToolkitProvider>
    </div>
  );
};
export default Employeemissionlist;
